// extracted by mini-css-extract-plugin
export default {"widget-header":"newCustomer_widget-header__mZ4fF","widget-body":"newCustomer_widget-body__m5nGn","dropdown-disabled":"newCustomer_dropdown-disabled__pgNzD"};